export default __webpack_public_path__ + "static/media/portfolio-smc360-6.fd58ec5c.jpg";